'use client';
import { motion, useMotionValue, useTransform } from 'motion/react';

type Props = {
  children: React.ReactNode;
  onSendToBack: () => void;
  sensitivity: number;
};

const CardRotate = ({ children, onSendToBack, sensitivity }: Props) => {
  const x = useMotionValue(0);
  const y = useMotionValue(0);
  const rotateX = useTransform(y, [-10, 10], [6, -6]);
  const rotateY = useTransform(x, [-10, 10], [-6, 6]);

  const handleDragEnd = (
    _: unknown,
    info: { offset: { x: number; y: number } },
  ) => {
    if (
      Math.abs(info.offset.x) > sensitivity ||
      Math.abs(info.offset.y) > sensitivity
    ) {
      onSendToBack();
    } else {
      x.set(0);
      y.set(0);
    }
  };

  return (
    <motion.div
      style={{
        x,
        y,
        rotateX,
        rotateY,
        position: 'absolute',
        width: '100%',
        height: '100%',
        cursor: 'grab',
      }}
      drag
      dragConstraints={{ top: 0, right: 0, bottom: 0, left: 0 }}
      dragElastic={0.6}
      whileTap={{ cursor: 'grabbing' }}
      onDragEnd={handleDragEnd}
    >
      {children}
    </motion.div>
  );
};

export default CardRotate;
